import React, { useEffect, useState } from 'react';
import './styles.css';
import { ReactInternetSpeedMeter } from 'react-internet-meter';

function Index({ progress }) {
  const [speedMbps, setSpeedMbps] = useState(0);
  const [status, setStatus] = useState('Desconocido');
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const testConnectionSpeed = async () => {
    if (!navigator.onLine) {
      setIsOnline(false);
      setStatus('Sin conexión');
      setSpeedMbps(0);
      return;
    }
  };

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      testConnectionSpeed();
    };

    const handleOffline = () => {
      setIsOnline(false);
      setStatus('Sin conexión');
      setSpeedMbps(0);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const getColor = () => {
    if (!isOnline || status === 'Sin conexión') return 'red';
    if (status === 'Buena') return 'limegreen';
    if (status === 'Regular') return 'orange';
    if (status === 'Mala') return 'red';
    return 'gray';
  };

  return (
    <div
      style={{
        backgroundSize: 'cover',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <img
        onClick={() => window.location.reload()}
        className={'logo'}
        src={require('./assets/672146f26d071.jpg')}
        alt="Logo"
      />

      <div style={{ marginTop: 20, width: '30%' }}>
        <div
          style={{
            background: '#2d2d2d',
            borderRadius: '10px',
            overflow: 'hidden',
            height: '22px',
            boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.3)',
            position: 'relative',
          }}
        >
          <div
            style={{
              height: '100%',
              width: `${progress}%`,
              backgroundImage:
                'linear-gradient(45deg, #4cafef 25%, transparent 25%, transparent 50%, #4cafef 50%, #4cafef 75%, transparent 75%, transparent)',
              backgroundSize: '40px 40px',
              backgroundColor: '#2196f3',
              animation: 'moveStripes 1s linear infinite',
              transition: 'width 0.3s ease',
            }}
          />
        </div>
        <div
          style={{
            color: 'white',
            marginTop: '8px',
            fontSize: '14px',
            textAlign: 'center',
          }}
        >
          {progress < 100
            ? `Downloading images: ${progress}%`
            : '✅ All images downloaded'}
        </div>
        <style>
          {`
            @keyframes moveStripes {
              0% { background-position: 0 0; }
              100% { background-position: 40px 0; }
            }
          `}
        </style>
      </div>

      {/* Indicador de conexión */}
      <div
        onClick={() => window.location.reload()}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          backgroundColor: '#222',
          padding: '8px 12px',
          borderRadius: 8,
          color: getColor(),
          fontWeight: 'bold',
          zIndex: 10,
        }}
      >
        {isOnline ? (
          speedMbps ? (
            <>
              📶 {speedMbps} Mbps - {status}
            </>
          ) : (
            <>🔄 Midiendo velocidad...</>
          )
        ) : (
          <>❌ Sin conexión</>
        )}
      </div>

      {/* Footer */}
      <div
        onClick={() => window.location.reload()}
        style={{
          position: 'absolute',
          bottom: 0,
          textAlign: 'center',
          backgroundColor: 'black',
          width: '100%',
        }}
      >
        <p style={{ color: 'white' }}>Powered by boostyourmenu.com V1.1</p>
      </div>
      <ReactInternetSpeedMeter
        txtSubHeading=""
        outputType="empty"
        customClassName={null}
        txtMainHeading=""
        pingInterval={4000} // milliseconds
        thresholdUnit="megabyte" // "byte" , "kilobyte", "megabyte"
        threshold={100}
        downloadSize="33353"
        imageUrl="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/WP20Symbols_MediaWiki_light_background.svg/312px-WP20Symbols_MediaWiki_light_background.svg.png"
        callbackFunctionOnNetworkDown={(speed) => {
          console.log(speed);
        }}
        callbackFunctionOnNetworkTest={setSpeedMbps}
      />
    </div>
  );
}

export default Index;
